import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import {
  DocketSettingsRootParamList,
  EditDocketTemplateRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import React from "react";
import DocketTemplate from "../../../../utilities/data/model/DocketTemplate";
import { useDatabase } from "@nozbe/watermelondb/react";
import { DocketTemplateFormProvider } from "../../components/DocketTemplateForm/DocketTemplateFormProvider";
import { ManageDocketTemplateScreenContext } from "../ManageDocketTemplateRootScreen/context";
import { ManageDocketTemplateRootScreen } from "../ManageDocketTemplateRootScreen";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";

const Stack = createStackHeaderNavigator<EditDocketTemplateRootParamList>();

export interface EditDocketTemplateRootScreenProps
  extends StackScreenProps<
    DocketSettingsRootParamList,
    "EditDocketTemplateRootScreen"
  > {}

export const EditDocketTemplateRootScreen = ({
  navigation,
  route,
}: EditDocketTemplateRootScreenProps) => {
  const database = useDatabase();
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  const [selectedDocket, setSelectedDocket] =
    React.useState<DocketTemplate | null>(null);

  const { docketTemplateId } = route.params;

  React.useEffect(() => {
    database
      .get<DocketTemplate>("docket_templates")
      .find(docketTemplateId)
      .then((docket) => {
        setSelectedDocket(docket);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [docketTemplateId]);

  const onAfterSubmitCallback = React.useCallback(async () => {
    await fetchAndSyncEntity("docket_templates");
    navigation.pop();
  }, []);

  if (!selectedDocket) {
    return null;
  }

  return (
    <ManageDocketTemplateScreenContext.Provider
      value={{ onAfterSubmit: onAfterSubmitCallback }}
    >
      <DocketTemplateFormProvider
        defaultFormValues={{
          id: selectedDocket.id,
          name: selectedDocket.name,
          enabled: selectedDocket.enabled,
          defaultTemplateTypeId: selectedDocket.defaultTemplateType.id,
          filters: selectedDocket.filters.map((filter) => ({
            type: filter.type,
            values: filter.values.map((value) => ({
              value: value,
            })),
          })),
          automaticallyPrint: selectedDocket.automaticallyPrint,
          terminalIds: selectedDocket.terminalIds ?? [],
        }}
      >
        <Stack.Navigator
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerShown: false,
          }}
        >
          <Stack.Screen
            name="ManageDocketTemplateRootScreen"
            component={ManageDocketTemplateRootScreen}
          />
        </Stack.Navigator>
      </DocketTemplateFormProvider>
    </ManageDocketTemplateScreenContext.Provider>
  );
};
